import { render, staticRenderFns } from "./tabCut.vue?vue&type=template&id=4c2b2958&scoped=true&"
import script from "./tabCut.vue?vue&type=script&lang=js&"
export * from "./tabCut.vue?vue&type=script&lang=js&"
import style0 from "./tabCut.vue?vue&type=style&index=0&id=4c2b2958&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b2958",
  null
  
)

export default component.exports